// Sfondo dell'app (public/sfondo-circuiti.svg, tracce di circuito generate
// su misura — nessuna licenza da rispettare, è disegnata da zero: le foto
// "circuito" libere trovate in giro erano tutte a pagamento, Unsplash+)
// coperto da una sfumatura quasi opaca del colore di pagina stesso, se ne
// vede solo un'eco invece di un disegno vero e proprio in mezzo a un
// gestionale. Usato sia da App.js (.app-shell) sia da SchermataLogin — le
// uniche due radici "pagina intera" dell'app. Inline (non in App.css): un
// url() dentro un file .css viene risolto da CRA come modulo relativo a
// src/, non trova public/ e la build fallisce; qui è solo una stringa JS a
// runtime, nessuna risoluzione di percorso in fase di build.
export function stileSfondoApp(temaScuro) {
  const sfumatura = temaScuro ? "rgba(15, 23, 42, 0.7)" : "rgba(248, 250, 252, 0.48)";
  return {
    backgroundImage: `linear-gradient(${sfumatura}, ${sfumatura}), url(${process.env.PUBLIC_URL}/sfondo-circuiti.svg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "fixed",
  };
}

// Tema chiaro/scuro dell'app: variabili CSS applicate su tutta l'app tramite
// l'attributo data-theme sul div radice. Estratto qui (invece di restare
// inline nel <style> di App) per essere renderizzato una sola volta e restare
// disponibile senza doverlo ridichiarare in ogni componente Tab.
export const CF_STYLE = `
        /* Tema chiaro/scuro: variabili CSS applicate su tutta l'app tramite
           l'attributo data-theme sul div radice. I valori "light" sono
           IDENTICI ai colori fissi usati finora (zero cambiamenti visivi in
           modalità chiara); "dark" riusa la stessa scala di grigi already in
           uso nell'header (già scuro), semplicemente invertita.
           L'header, il pannello Impostazioni e i badge di stato colorati
           (verde/arancio/rosso/viola) restano fissi in entrambi i temi: sono
           già pensati per leggersi bene su qualunque sfondo. */
        [data-theme="light"] {
          color-scheme: light;
          --cf-bg-page: #f8fafc;
          --cf-bg-card: #ffffff;
          --cf-bg-subtle: #f1f5f9;
          --cf-border: #e2e8f0;
          --cf-border-strong: #cbd5e1;
          --cf-text-primary: #1e293b;
          --cf-text-secondary: #475569;
          --cf-text-muted: #64748b;
          --cf-text-faint: #94a3b8;
          --cf-text-heading: #334155;
          --cf-accent: #1e3a8a;
          --cf-shadow: rgba(0,0,0,0.05);
          /* Colori di stato (completato/in lavorazione/errore/spedizione in
             corso/info): in chiaro sono i pastelli fissi di sempre. */
          --cf-success-bg: #f0fdf4;
          --cf-success-text: #166534;
          --cf-success-border: #22c55e;
          --cf-warning-bg: #fff7ed;
          --cf-warning-text: #92400e;
          --cf-warning-border: #f59e0b;
          --cf-danger-bg: #fef2f2;
          --cf-danger-text: #b91c1c;
          --cf-danger-border: #fca5a5;
          --cf-purple-bg: #faf5ff;
          --cf-purple-text: #7e22ce;
          --cf-purple-border: #a855f7;
          --cf-info-bg: #eef2ff;
          --cf-info-text: #4338ca;
          --cf-info-border: #a5b4fc;
          /* Tema "Materiali" (marrone/crema, volutamente diverso dal resto
             dell'app per distinguere quella vista): in chiaro i colori caldi
             fissi di sempre. */
          --cf-mat-bg: #fdf8f0;
          --cf-mat-bg-track: #f1e5d3;
          --cf-mat-border: #e8dcc8;
          --cf-mat-border-strong: #c9a876;
          --cf-mat-text: #6b4423;
          --cf-mat-text-secondary: #8a6d4f;
        }
        [data-theme="dark"] {
          color-scheme: dark;
          --cf-bg-page: #0f172a;
          --cf-bg-card: #1e293b;
          --cf-bg-subtle: #263449;
          --cf-border: #334155;
          --cf-border-strong: #475569;
          --cf-text-primary: #f1f5f9;
          --cf-text-secondary: #cbd5e1;
          --cf-text-muted: #94a3b8;
          --cf-text-faint: #64748b;
          --cf-text-heading: #e2e8f0;
          --cf-accent: #60a5fa;
          --cf-shadow: rgba(0,0,0,0.4);
          /* Stessa logica dei pastelli chiari, ma "accesi" su sfondo scuro:
             tinta scura traslucida invece di pastello pieno, testo e bordo
             nella tonalità satura piena (già ben visibile su scuro). */
          --cf-success-bg: rgba(34, 197, 94, 0.16);
          --cf-success-text: #4ade80;
          --cf-success-border: #22c55e;
          --cf-warning-bg: rgba(245, 158, 11, 0.16);
          --cf-warning-text: #fbbf24;
          --cf-warning-border: #f59e0b;
          --cf-danger-bg: rgba(239, 68, 68, 0.16);
          --cf-danger-text: #f87171;
          --cf-danger-border: #ef4444;
          --cf-purple-bg: rgba(168, 85, 247, 0.16);
          --cf-purple-text: #c084fc;
          --cf-purple-border: #a855f7;
          --cf-info-bg: rgba(99, 102, 241, 0.16);
          --cf-info-text: #a5b4fc;
          --cf-info-border: #6366f1;
          /* Tema "Materiali" scuro: stessa identità calda (marrone/ambra),
             non il blu-grigio del resto dell'app, ma con contrasto adeguato
             su sfondo scuro invece del pastello crema pieno. */
          --cf-mat-bg: #2b2015;
          --cf-mat-bg-track: #3a2c1c;
          --cf-mat-border: #4a3826;
          --cf-mat-border-strong: #6b5636;
          --cf-mat-text: #e8d4b8;
          --cf-mat-text-secondary: #c9a876;
        }
        /* Scrollbar di sistema (pagina e qualunque div con overflow interno):
           di default il browser le disegna sempre chiare, anche su sfondo
           scuro. Le adattiamo al tema solo in modalità scura (in chiara resta
           l'aspetto nativo di sempre). */
        [data-theme="dark"] {
          scrollbar-color: var(--cf-border-strong) var(--cf-bg-subtle);
        }
        [data-theme="dark"] ::-webkit-scrollbar {
          width: 12px;
          height: 12px;
        }
        [data-theme="dark"] ::-webkit-scrollbar-track {
          background: var(--cf-bg-subtle);
        }
        [data-theme="dark"] ::-webkit-scrollbar-thumb {
          background: var(--cf-border-strong);
          border-radius: 6px;
        }
        [data-theme="dark"] ::-webkit-scrollbar-thumb:hover {
          background: var(--cf-text-faint);
        }
        /* I controlli di form (input/textarea/select) non ereditano sempre
           il colore del testo né il font dagli antenati come i div normali
           (peculiarità dei browser: di default usano il font di sistema, es.
           Arial su Windows, invece di quello della pagina): regola esplicita,
           bassa priorità — qualunque stile inline già presente sui singoli
           campi (es. quelli nell'header, già scuri e in Roboto Mono di
           proposito) vince comunque su questa. */
        input, textarea, select {
          color: var(--cf-text-primary);
          font-family: inherit;
        }
        .cf-btn {
          transition: filter 0.15s ease, background-color 0.15s ease, color 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease;
        }
        .cf-btn:not(:disabled):hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 10px rgba(0,0,0,0.15);
        }
        .cf-btn:not(:disabled):active {
          transform: translateY(0);
        }
        /* Pulsanti "azione" su sfondo chiaro: normalmente solo bordo e testo
           colorati, si riempiono con il colore pieno solo al passaggio del
           mouse. Il colore si passa via CSS variable --btn-color. */
        .cf-btn-outline {
          background-color: var(--cf-bg-card);
          border: 2px solid var(--btn-color, #1e3a8a);
          color: var(--btn-color, #1e3a8a);
        }
        .cf-btn-outline:not(:disabled):hover {
          background-color: var(--btn-color, #1e3a8a);
          color: #fff;
        }
        .cf-btn-outline:not(:disabled):active {
          filter: brightness(0.92);
        }
        .cf-btn-outline:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        /* Variante per pulsanti "azione" su sfondo scuro (es. header): bordo
           e testo bianchi, si riempiono di bianco al passaggio del mouse. */
        .cf-btn-outline-light {
          background-color: transparent;
          border: 2px solid #fff;
          color: #fff;
        }
        .cf-btn-outline-light:not(:disabled):hover {
          background-color: #fff;
          color: var(--btn-hover-text, #1e3a8a);
        }
        .cf-btn-outline-light:not(:disabled):active {
          filter: brightness(0.92);
        }
        /* Variante "pericolo" della cf-btn-outline-light: bordo/testo rossi
           su sfondo scuro, si riempiono di rosso pieno (testo bianco) al
           passaggio del mouse, invece di sfondo bianco. */
        .cf-btn-outline-danger-light {
          background-color: transparent;
          border: 2px solid #ef4444;
          color: #ef4444;
        }
        .cf-btn-outline-danger-light:not(:disabled):hover {
          background-color: #ef4444;
          color: #fff;
        }
        .cf-btn-outline-danger-light:not(:disabled):active {
          filter: brightness(0.92);
        }
        /* Tabella "grezza" di PRODUZIONE (sotto i grafici a torta): con
           molte colonne di filtro non deve schiacciarle tutte nella
           larghezza disponibile, altrimenti diventano illeggibili. Ogni
           colonna tiene una larghezza minima e il contenitore scorre in
           orizzontale quando serve. */
        .cf-tabella-produzione-wrapper {
          overflow-x: auto;
          /* Scroll ancora funzionante (trackpad, rotellina, drag) ma
             scrollbar nativa nascosta: ridondante ora che c'è quella
             "specchio" sempre visibile nella barra fluttuante sopra. */
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none; /* Edge/IE legacy */
        }
        .cf-tabella-produzione-wrapper::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Edge Chromium */
        }
        .cf-tabella-produzione th {
          min-width: 160px;
        }
        .cf-tabella-produzione td {
          white-space: nowrap;
        }
        @keyframes cf-pulse {
          0%, 100% { opacity: 1; box-shadow: 0 0 4px currentColor; }
          50% { opacity: 0.4; box-shadow: 0 0 10px currentColor; }
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
`;
